import {
    getProductLineItem,
    listProductLineItems
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductLineItem,
    DeleteProductLineItem,
    GetProductLineItem,
    ListProductLineItems,
    ProductLineItem,
    UpdateProductLineItem
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    createProductLineItem,
    deleteProductLineItem,
    updateProductLineItem
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery & { productId: string }) => {
    const response = await client.graphql<GraphQLQuery<ListProductLineItems>>({
        query: listProductLineItems,
        variables: {
            productId: query.productId,
            limit: query.limit,
            sort: query.sort,
            nextToken: query.nextToken
        }
    });

    return {
        items: response.data?.listProductLineItems.items,
        nextToken: response.data?.listProductLineItems.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProductLineItem>>({
                                                                                query: getProductLineItem,
                                                                                variables: {id: id},
                                                                            });
    return response.data?.getProductLineItem;
};

// Inputs are WHITELISTED to the API input types (billing-api product-line-items.graphql).
// Naming the fields sent means a field the form happens to carry (the nested `product`,
// `productFeature`, `created`) can never reach AppSync, which rejects the whole call for
// one undeclared field.
//
// CreateProductLineItemInput: productId!, productFeatureId!, position, createdByUsername, created
export const buildCreateProductLineItemInput = (productId: string, values: Partial<ProductLineItem>) => ({
    productId,
    productFeatureId: values.productFeatureId,
    position: values.position,
});

// UpdateProductLineItemInput: id!, productId!, productFeatureId!, position, updated
export const buildUpdateProductLineItemInput = (id: string, values: Partial<ProductLineItem>) => ({
    id,
    productId: values.productId,
    productFeatureId: values.productFeatureId,
    position: values.position,
});

export const add = async (productId: string, values: Partial<ProductLineItem>) => {
    const response = await client.graphql<GraphQLQuery<CreateProductLineItem>>({
                                                                                   query: createProductLineItem,
                                                                                   variables: {input: buildCreateProductLineItemInput(productId, values)},
                                                                               });
    return response.data?.createProductLineItem;
};

export const update = async (id: string, values: Partial<ProductLineItem>) => {
    const response = await client.graphql<GraphQLQuery<UpdateProductLineItem>>({
                                                                                   query: updateProductLineItem,
                                                                                   variables: {input: buildUpdateProductLineItemInput(id, values)},
                                                                               });
    return response.data?.updateProductLineItem;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProductLineItem>>({
                                                                                   query: deleteProductLineItem,
                                                                                   variables: {input: {id: id}},

                                                                               });
    return response.data?.deleteProductLineItem;
};
